module.exports = __webpack_public_path__ + "img/card_monitoreo.00d93021.jpg";